<template>
  <GlobalWindow
    v-loading="isUploading"
    :title="title"
    width="500px"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-suffix="："   >
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" :maxlength="5" v-trim/>
      </el-form-item>
      <el-form-item label="展示图" prop="imgurlfull">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgFullurl, 'imgurl': form.imgurl }"
          :upload-data="{folder:'labels'}"
          @uploadSuccess="uploadAvatarSuccess"
          @uploadEnd="isUploading=false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="选中商品" prop="applyIdList" >
        <span style="font-size: 12px;color: #216EEE"   @click="selectGoods">已指定【 {{applyDataList.length}} 】件商品</span>
        <el-button style="margin-left:30px;display: inline-block;width: 80px;" type="primary"  @click="selectGoods">去选择 </el-button>
      </el-form-item>
      <el-form-item label="排序码" prop="sortnum">
        <el-input type="number" v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input type="textarea" v-model="form.info" placeholder="请输入备注" :maxlength="200" v-trim/>
      </el-form-item>
    </el-form>
    <OperaCouponGoodsWindow ref="OperaCouponGoodsWindow" @success="doSelect"/>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import OperaCouponGoodsWindow from '@/components/business/OperaCouponGoodsWindow'
import { allList as goodsList } from '@/api/business/goods'
export default {
  name: 'OperaLabelsWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage, OperaCouponGoodsWindow },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        name: '',
        info: '',
        type: null,
        status: '',
        parentId: null,
        sortnum: null,
        imgFullurl: null,
        applyIdList: [],
        imgurl: ''
      },
      applyDataList: [],
      // 验证规则
      rules: {
        parentId: [{ required: true, message: '请选择所属品牌' }],
        name: [{ required: true, message: '请输入名称', tigger: 'blur' }]
      }
    }
  },
  inject: ['labels'],
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  },
  methods: {
    selectGoods () {
      this.$refs.OperaCouponGoodsWindow.open('选择商品', this.applyDataList)
    },
    doSelect (rows) {
      console.log(rows, this.applyDataList)
      this.applyDataList = []
      this.form.applyIdList = []
      if (rows && rows.length) {
        rows.forEach(item => {
          this.applyDataList.push(item)
          this.form.applyIdList.push(item.id)
        })
      }
      this.$refs.form.clearValidate()
    },
    open (title, target, type) {
      this.title = title
      this.visible = true
      this.applyDataList = []
      this.form.applyIdList = []
      this.form.imgFullurl = null
      this.form.imgurl = null
      this.goods = []
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form.provinceId = ''
          this.form[this.configData['field.id']] = null
          this.form.type = type
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.type = type
        this.loadSelectGoods()
      })
    },
    loadSelectGoods () {
      goodsList({
        zhuanquId: this.form.id // 商品分类
      }).then(res => {
        this.applyDataList = res || []
        this.applyDataList.forEach(t => {
          this.form.applyIdList.push(t.id)
        })
      })
    },
    // 上传图片
    uploadAvatarSuccess (file) {
      this.form.imgurl = file.imgurl
      this.form.imgFullurl = file.imgurlfull
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
$image-width: 100px;

::v-deep .el-select {
    width: 100%;
    .el-input__inner {
      width: 100%;
    }
  }
.avatar-uploader {
  width: $image-width;
  height: $image-width;
}
::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: $image-width;
  height: $image-width;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: $image-width;
  height: $image-width;
  line-height: $image-width;
  text-align: center;
}
.avatar {
  width: $image-width;
  height: $image-width;
  display: block;
}
</style>
